// import { Map, List } from "immutable";
import { createListReducer } from "./base-reducers";
import LenderActions from "../constants/actions";
import { UserRecord } from "../records";

const listReducer = createListReducer(LenderActions.USERS.LIST, UserRecord);

export default (state, action) => {
    return [
        listReducer
    ].reduce((state, reducer) => reducer(state, action), state);
};